const trackEvent = (name, attributes = {}, { providers = [] } = {}) => {
  if (typeof ga !== 'undefined' && providers.includes(ga)) {
    // no mapping between providers; need explicit params
    const { eventAction, eventCategory, eventLabel, eventValue } = attributes;
    ga('send', 'event', {
      eventAction,
      eventCategory,
      eventLabel,
      eventValue,
    });
  }
  if (
    typeof mParticle !== 'undefined' &&
    mParticle.EventType &&
    providers.includes(mParticle)
  ) {
    mParticle.logEvent(name, mParticle.EventType.Navigation, attributes);
  }
  // facebook tracking
  if (typeof fbq !== 'undefined' && providers.includes(fbq)) {
    fbq('track', name);
  }

  if (typeof Adjust !== 'undefined' && providers.includes(Adjust)) {
    const { eventToken, userId } = attributes;
    Adjust.trackEvent({
      eventToken,
      ...(userId && {
        callbackParams: [{ key: 'user_id', value: `${userId}` }],
      }),
    });
  }
};

export default trackEvent;
